import ja from '@/internationalization/trans/chefs/ja/ja.json';
export default {
  trans: ja,
};
